import { format, lastDayOfWeek, parse, startOfWeek } from "date-fns";
import { formatInTimeZone, toDate } from "date-fns-tz";

// eslint-disable-next-line new-cap
export const makeLocalDate = (utcDateString) => toDate(utcDateString, Intl.DateTimeFormat().resolvedOptions().timeZone);

export const queryDateFormatString = "yyyy-MM-dd";
export const queryDateFormat = (dateToFormat) => format(dateToFormat, queryDateFormatString);
export const getQueryDate = (dateString) => {
	if (dateString) {
		try {
			const newDate = parse(dateString, queryDateFormatString, new Date());

			if (newDate.toString() === "Invalid Date") {
				return new Date();
			}

			return newDate;
		// eslint-disable-next-line no-empty
		} catch (error) {}
	}
	return new Date();
};

export const getTimezone = () => window.lwc_timezone || "America/New_York";


export const displayDate = (date, dateFormat) => {
	try {
		return format(date, dateFormat, { timeZone: getTimezone() });
	// eslint-disable-next-line no-empty
	} catch (error) {}
	return "";
};

/**
 * Format a Date
 *
 * @see https://date-fns.org/v3.3.1/docs/format
 *
 * @param {*} date
 * @param {*} dateFormat
 * @returns
 */
export const displaySystemDate = (date, dateFormat) => {
	try {
		return formatInTimeZone(date, getTimezone(), dateFormat);
	// eslint-disable-next-line no-empty
	} catch (error) {}
	return "";
};

export const getIncrementUnit = (view) => {
	switch (view) {
	case "agenda":
		return "months";
	default:
		return `${view}s`;
	}
};

export const getRangeLabel = (date, view = "month") => {
	const weekFormat = "MMM d";

	switch (view) {
	case "day":
		return format(date, weekFormat);
	case "week":
		return `${format(startOfWeek(date), weekFormat)} - ${format(lastDayOfWeek(date), weekFormat)}`;
	case "month":
	default:
		return format(date, "MMMM yyyy");
	}
};

export const graphqlDate = (date = null) => {
	if (!date) {
		// eslint-disable-next-line no-param-reassign
		date = new Date();
	}

	return {
		day: date.getDate(),
		month: date.getMonth() + 1,
		year: date.getFullYear()
	};
};

/**
 * Display Event Start Date
 *
 * @see https://date-fns.org/v2.30.0/docs/format
 *
 * @param {*} event
 * @param {*} dateFormat
 * @returns
 */
export const displayEventLocalStartDate = (event, dateFormat = "yyyy-MM-dd") => {
	try {
		// eslint-disable-next-line new-cap
		const date = toDate(event.start, Intl.DateTimeFormat().resolvedOptions().timeZone);
		return format(date, dateFormat);
	} catch (error) {
		return "";
	}
};

/**
 * Display Event Start Date
 *
 * @see https://date-fns.org/v2.30.0/docs/format
 *
 * @param {*} event
 * @param {*} dateFormat
 * @returns
 */
export const displayEventSystemStartDate = (event, dateFormat = "yyyy-MM-dd") => {
	try {
		// eslint-disable-next-line new-cap
		const date = toDate(event.start, getTimezone());
		return formatInTimeZone(date, getTimezone(), dateFormat);
	} catch (error) {
		return "";
	}
};

export const formatUtc = (utcDate, dateFormat = "yyyy-MM-dd") => format(
	// eslint-disable-next-line new-cap
	toDate(utcDate, Intl.DateTimeFormat().resolvedOptions().timeZone),
	dateFormat
);
